import { render, staticRenderFns } from "./subspace-manage.vue?vue&type=template&id=424da3d3&scoped=true"
import script from "./subspace-manage.vue?vue&type=script&lang=js"
export * from "./subspace-manage.vue?vue&type=script&lang=js"
import style0 from "./subspace-manage.vue?vue&type=style&index=0&id=424da3d3&prod&lang=less&scoped=true"
import style1 from "./subspace-manage.vue?vue&type=style&index=1&id=424da3d3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424da3d3",
  null
  
)

export default component.exports